import {FILTER_FETCHED} from "../types";

export const modalFetched = news => ({
    type: FILTER_FETCHED,
    news
});


export const filterRegion = () => (dispatch, getState) => {

};








// WEBPACK FOOTER //
// ./src/actions/filter.js